import { useState } from "react";
import Image from "next/image";

export default function FunImage({
  src,
  alt,
  ...props
}: {
  src: string;
  alt: string;
}) {
  const [imgError, setImgError] = useState(false);

  return (
    <div
      className={`${imgError ? "bg-black/80" : ""} relative flex h-full w-full items-center justify-center`}
    >
      {!imgError ? (
        <Image
          {...props}
          src={src}
          alt={alt}
          quality={100}
          fill
          sizes="(max-width: 768px) 100vw, 80vw"
          className={`h-full w-full object-cover object-center`}
          onError={() => setImgError(true)}
        />
      ) : (
        <span className="w-full p-3 text-center text-[.9rem] text-white">
          Image Not Found
        </span>
      )}
    </div>
  );
}
